import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  AddReviewReqProps,
  AddReviewResProps,
  GetAvailableDatesReqProps,
  GetAvailableDatesResProps,
  GetAvailableTimesReqProps,
  GetAvailableTimesResProps,
  GetCombinedAvailabilityReqProps,
  GetCombinedAvailabilityResProps,
  GetProviderReqProps,
  GetProviderResProps,
  GetReviewReqProps,
  GetReviewResProps
} from './providers.types';

export const providersApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    addReview: build.mutation<AddReviewResProps, AddReviewReqProps>({
      query: ({ doctorId, ...body }) => ({
        body,
        method: 'PUT',
        url: `doctors/${doctorId}/review`
      })
    }),
    getAvailableDates: build.query<GetAvailableDatesResProps, GetAvailableDatesReqProps>({
      query: ({ accessToken, doctorId, ...params }) => ({
        headers: {
          'API-KEY': import.meta.env.VITE_API_KEY,
          ...(accessToken && { Authorization: accessToken })
        },
        params,
        url: `doctors/${doctorId}/available-dates`
      })
    }),
    getAvailableTimes: build.query<GetAvailableTimesResProps, GetAvailableTimesReqProps>({
      query: ({ accessToken, doctorId, ...params }) => ({
        headers: {
          'API-KEY': import.meta.env.VITE_API_KEY,
          Authorization: accessToken
        },
        params,
        url: `doctors/${doctorId}/availability`
      })
    }),
    getCombinedAvailability: build.query<
      GetCombinedAvailabilityResProps,
      GetCombinedAvailabilityReqProps
    >({
      query: (params) => ({
        params,
        url: '/doctors/combined-availability'
      })
    }),
    getProvider: build.query<GetProviderResProps, GetProviderReqProps>({
      query: ({ providerId }) => `doctors/${providerId}?reviewLimit=2`
    }),
    getProviderReviews: build.query<GetReviewResProps, GetReviewReqProps>({
      keepUnusedDataFor: 0,
      query: ({ providerId, ...params }) => ({
        params,
        url: `doctors/${providerId}/reviews`
      })
    })
  }),
  reducerPath: 'providersApi',
  tagTypes: ['Providers']
});

export const {
  useAddReviewMutation,
  useGetProviderQuery,
  useGetProviderReviewsQuery,
  useLazyGetAvailableDatesQuery,
  useLazyGetAvailableTimesQuery,
  useLazyGetCombinedAvailabilityQuery,
  useLazyGetProviderQuery,
  useLazyGetProviderReviewsQuery
} = providersApi;
